module.exports = __webpack_public_path__ + "static/media/noimage.f23fa3ea.jpg";